import { createContext, useState } from "react";
import { eventsEmitter } from "utils/events";
import { EVENTS } from "const";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchAction, setSearchAction] = useState(null);

  const triggerSearchAction = (action) => {
    setSearchAction({ type: action, timestamp: Date.now() });
    eventsEmitter.emit(EVENTS.SEARCH_ACTION, action);
  };

  const clearSearchAction = () => {
    setSearchAction(null);
  };

  return (
    <SearchContext.Provider value={{ searchTerm, setSearchTerm, searchAction, triggerSearchAction, clearSearchAction }}>
      {children}
    </SearchContext.Provider>
  );
};

export default SearchContext;
